import Vue from 'vue'
import Router from 'vue-router'

import Index from "@/pages/Index.vue";
import CarView from "@/pages/CarView.vue";
import Favorites from "@/pages/Favorites.vue";
import Notification from "@/pages/Notification.vue";
import Dealers from "@/pages/Dealers.vue";
import DealersCar from "@/pages/DealerViewCar.vue";
import Profile from "@/pages/Profile.vue";
import Register from "@/components/login/Register.vue";
import Welcome from "@/components/profile/Welcome.vue";
import SignIn from "@/components/login/SignIn.vue";
import Forgot from "@/components/login/Forgot.vue";

import ForgotChangePass from "@/components/login/ForgotChangePass.vue";
import App from "@/pages/App.vue";
import Terms from "@/pages/Terms.vue";
import AutoLogin from "@/pages/AutoLogin.vue";
import PriceList from "@/pages/PriceList.vue";
import NotFound from "@/components/NotFound.vue";
import FbCallback from "@/components/FbCallback";
import Skiptirmali from "@/components/Skiptirmali";
import device from "current-device";

import AboutProject from "@/pages/AboutProject";

import carsInStock from './carsInStock'
import blog from './blog'

import routesNames from '@/router/constants'

const routes = [
    {path: "/", redirect: routesNames.newCars},
    {path: "/:controller/not-found", component: NotFound, name: '404page'},

    {path: routesNames.oldCars, component: Index, name: "OldCars"},
    {path: '/k7', component: Index, name: "k7Cars"},
    {path: `/k7/:id(\\d+)`, component: CarView, name: "k7Car"},
    {path: `/k7/:brand`, component: Index, name: "k7Cars"},
    {path: `/k7/:brand/:model`, component: Index, name: "k7Cars"},


    {path: `${routesNames.oldCars}/:id(\\d+)`, component: CarView, name: "Car"},

    {path: `${routesNames.oldCars}/:brand`, component: Index, name: "OldCars"},
    {path: `${routesNames.oldCars}/:brand/:model`, component: Index, name: "OldCars"},

    {path: routesNames.newCars, name: "DealersCars", component: Dealers},
    {path: `${routesNames.newCars}/:id(\\d+)`, name: "DealerCar", component: DealersCar},
    {path: `${routesNames.newCars}/:brand`, name: "DealersCars", component: Dealers},
    {path: `${routesNames.newCars}/:brand/:model`, name: "DealersCars", component: Dealers},

    {path: "/favorites", component: Favorites, name: 'Favorites', meta: {title: "Favorites"}},
    {path: "/notifications", component: Notification, name: 'Notification'},

    {path: "/tilbodsbilar", component: Index, /* redirect: "/bilaumbod" */},
    {path: "/profiles", component: Profile, name: 'Profile'},
    {path: "/register", component: Register},
    {path: "/sign-in", component: SignIn},
    {path: "/welcome", component: Welcome},
    {path: "/forgot", component: Forgot},
    {path: "/forgot/:id/:key", component: ForgotChangePass},
    {path: "/app", component: App},
    {path: "/terms-and-conditions", component: Terms},
    {path: "/auto-login", component: AutoLogin},
    {path: "/about-project", component: AboutProject, name: 'AboutProject'},
    {path: "/price-list/:id", component: PriceList, name: 'PriceList'},
    {path: "/facebook", component: FbCallback},
    {path: "/skiptirmali", component: Skiptirmali},

    ...carsInStock,
    ...blog,
    {path: "/*", component: NotFound, name: 'global-404page'},
];

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (!savedPosition) {
            return { x: 0, y: 0 };
        }
        return savedPosition;
        /*
        if (device.mobile() &&
          (to.name == 'OldCars' && from.name == 'OldCars' ||
          to.name == 'DealersCars' && from.name == 'DealersCars')
        ) {
          return savedPosition
        }
        if (savedPosition) {
            return savedPosition
          } else {
            return { x: 0, y: 0 }
          }

         */
    }
})

router.afterEach((to) => {
    gtag('config', 'UA-37875116-2', {
        page_path: to.fullPath,
        app_name: 'Bilaskra',
        send_page_view: true,
    })
})

export default router